import { QuoteTheme } from '@shared/components/quote/enum';
import { QuoteStyle } from '@shared/components/quote/model/quote-style';

export const quoteStyle = {
  [QuoteTheme.WHITE]: {
    legendColor: 'GREY_ALPHA',
    textColor: 'WHITE',
  } as QuoteStyle,
  [QuoteTheme.BROWN]: {
    textColor: 'BROWN',
  } as QuoteStyle,
};
